export default __webpack_public_path__ + "static/insta2-aeac88a676ac0666ef7402c6e666f7fc.png";